import { el } from '../../core/dom.js';
import { openModal } from '../../components/modal.js';
import {
  normalizeSlotTime, sessionTitle, statusPill, weekdayName,
} from './model.js';

function dayBlock(day, handlers) {
  const weekday = Number(day.weekday);
  return el('div', { class: 'org-cal-day' },
    el('div', { class: 'org-cal-day-name' }, day.name || weekdayName(weekday)),
    el('div', { class: 'org-cal-slots' },
      (day.slots || []).map((slot) => el('button', {
        type: 'button',
        class: 'org-cal-slot',
        title: 'Remove slot',
        onClick: () => handlers.onRemoveSlot(slot.id),
      },
      el('span', {}, slot.label || slot.time_hhmm || '—'),
      el('span', { 'aria-hidden': 'true' }, '×'))),
      el('button', {
        type: 'button',
        class: 'org-cal-add',
        onClick: () => openAddSlot(weekday, handlers.onAddSlot),
      }, '+ Add slot')));
}

function openAddSlot(weekday, onAdd) {
  const holder = { close() {} };
  const err = el('p', { class: 'org-form-err', hidden: true });
  const input = el('input', {
    class: 'org-input',
    type: 'time',
    value: '10:00',
  });
  const body = el('div', { class: 'org-form' },
    err,
    el('p', { class: 'org-hint' }, `Pick a time for ${weekdayName(weekday)}.`),
    el('label', { class: 'org-field' },
      el('span', {}, 'Time'),
      input),
    el('div', { class: 'org-form-actions' },
      el('button', {
        type: 'button',
        class: 'org-btn',
        onClick: () => holder.close(),
      }, 'Cancel'),
      el('button', {
        type: 'button',
        class: 'org-cta',
        onClick: async () => {
          const time = normalizeSlotTime(input.value);
          if (!time) {
            err.textContent = 'Enter a valid time';
            err.hidden = false;
            return;
          }
          err.hidden = true;
          const ok = await onAdd(weekday, time);
          if (ok) holder.close();
        },
      }, 'Add slot')));
  const modal = openModal({ title: 'Add slot', className: 'org-modal', body });
  holder.close = modal.close;
  input.focus();
}

export function renderCalendar(state, handlers) {
  const days = state.calendarDays || [];
  const sessions = state.calendarSessions || [];
  return el('section', { class: 'org-detail org-cal', 'aria-label': 'Global calendar' },
    el('div', { class: 'org-cal-head' },
      el('h2', {}, 'Global calendar'),
      el('p', {}, 'One set of slots serves every organization\'s booking picker. Booked slots show who claimed them.')),
    el('div', { class: 'org-cal-card' },
      days.length
        ? days.map((day) => dayBlock(day, handlers))
        : el('p', { class: 'org-thread-empty' }, 'No weekdays configured yet.')),
    el('div', { class: 'org-cal-upcoming' },
      el('h3', {}, 'Upcoming sessions — all organizations'),
      el('div', { class: 'org-cal-sessions' },
        sessions.length
          ? sessions.map((row) => el('div', { class: 'org-cal-session' },
            el('div', { class: 'org-cal-session-org' }, row.tenant_name || 'Organization'),
            el('div', { class: 'org-cal-session-meta' },
              `${sessionTitle(row)} · Booked by ${row.booked_by_name || row.booked_by_email || 'Unknown'}`),
            el('span', { class: 'org-pill' }, statusPill(row.status))))
          : el('p', { class: 'org-thread-empty' }, 'No upcoming sessions.'))));
}
